module.exports = __webpack_public_path__ + "img/discoverEn.8d0db954.png";